import {Component, Input, OnInit} from '@angular/core';
import { EquipmentDiagnosis } from '../../../shared/model/equipment-diagnosis';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';
import { AttributeState } from '../../model/attribute-state';

@Component({
  selector: 'tx-equipment-diagnosis',
  templateUrl: './equipment-diagnosis.component.html',
  styleUrls: ['./equipment-diagnosis.component.css']
})
export class EquipmentDiagnosisComponent implements OnInit {
  _equipmentDiagnosis: EquipmentDiagnosis;
  equipment: any = {};
  running = false;
  loadingText: string;
  _run: boolean;

  constructor(private _diagnosisNotification: DiagnosisWebSocketService) {

  }

  ngOnInit() {
    if (this._run) {
      this.observeRestart();
      this.setEmptyEntities();
      this.subscribeEquipmentSuccess();
      this.subscribeEquipmentFail();
    } else {
      this.displayViewMode();
    }
  }

  get run() {
    return this._run;
  }

  @Input()
  set run(run) {
    this._run = run;
  }

  get equipmentDiagnosis() {
    return this._equipmentDiagnosis;
  }

  @Input()
  set equipmentDiagnosis(equipmentDiagnosis) {
    this._equipmentDiagnosis = equipmentDiagnosis;
    this.equipment = equipmentDiagnosis;
  }

  observeRestart() {
    this._diagnosisNotification.restart$
      .subscribe(() => {
        this.setEmptyEntities();
        this.running = true;
      });
  }

  setEmptyEntities() {
    this.loadingText = 'Carregando...';
    this._equipmentDiagnosis = new EquipmentDiagnosis();
    this.equipment = new EquipmentDiagnosis();
  }

  subscribeEquipmentSuccess() {
    this._diagnosisNotification.success$
      .filter(data => data instanceof EquipmentDiagnosis)
      .subscribe(equipmentDiagnosis => {
        this.setAttributeState(equipmentDiagnosis, AttributeState.SUCCESS);
        this.updateDiagnosisDisplay(equipmentDiagnosis);
      });
  }

  subscribeEquipmentFail() {
    this._diagnosisNotification.failed$
      .filter(data => data instanceof EquipmentDiagnosis)
      .subscribe(equipmentDiagnosis => {
        this.setAttributeState(equipmentDiagnosis, AttributeState.FAIL);
        this.updateDiagnosisDisplay(equipmentDiagnosis);
      });
  }

  private updateDiagnosisDisplay(equipmentDiagnosis) {
    this._equipmentDiagnosis = equipmentDiagnosis;
    this.running = this._equipmentDiagnosis.isRunning;
    if (!this.running) {
      this.loadingText = 'Indisponível';
    }
  }

  private setAttributeState(equipmentResponse, state) {
    Object.keys(equipmentResponse).forEach((key) => {
      if (!(key in this._equipmentDiagnosis)) {
        this.equipment[key] = state;
      }
    });
  }

  private displayViewMode() {
    this.setupEquipmentStatus();
    this._equipmentDiagnosis = this._equipmentDiagnosis.equipmentData;
  }

  private setupEquipmentStatus() {
    let equipStatus = {'profileName': this._equipmentDiagnosis.profile, 'configGroup': this._equipmentDiagnosis.configGroup,
      'configStatus': this._equipmentDiagnosis.configStatus, 'firmwareVersion': this._equipmentDiagnosis.firmwareVersion,
      'firmwareStatus': this._equipmentDiagnosis.firmwareStatus,
      'calampAccumulatorsConfigured': this._equipmentDiagnosis.calampAccumulatorsConfigured,
      'phoneNumber': this._equipmentDiagnosis.phoneNumber};

    Object.keys(equipStatus).forEach((key) => {
      this.setStateOnAtrribute(key, equipStatus[key]);
    });
  }

  private setStateOnAtrribute(key, value) {
    if (value) {
      this.equipment[key] = AttributeState.SUCCESS;
    } else {
      this.equipment[key] = AttributeState.FAIL;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/equipment-diagnosis/equipment-diagnosis.component.ts